import { useLocalStorage } from 'usehooks-ts';

export function useTilesLocalStorage() {
  const [hiddenTiles, setHiddenTiles] = useLocalStorage<string[]>(
    'qualityMonitor-hiddenTiles',
    []
  );
  const [tilesOrder, setTilesOrder] = useLocalStorage<string[]>(
    'qualityMonitor-tileOrder',
    []
  );

  return { hiddenTiles, setHiddenTiles, tilesOrder, setTilesOrder };
}
